/**
 * The configs for the various Dow Jones logos
 * TODO: need to find a better system, so this is importanble
 */
import IconWsj from '../Icon/IconWsj';
import IconMarketwatch from '../Icon/IconMarketwatch';
import IconBarrons from '../Icon/IconBarrons';
import IconFnlondon from '../Icon/IconFnlondon';
import IconPen from '../Icon/IconPen';
import IconMansionglobal from '../Icon/IconMansionglobal';
import IconMansionglobalBoutique from '../Icon/IconMansionglobalBoutique';
import IconDowjones from '../Icon/IconDowjones';
import IconThetimes from '../Icon/IconThetimes';
import IconWsjopinion from '../Icon/IconWsjopinion';
import IconWsjChina from '../Icon/IconWsjChina';
import IconWsjJapan from '../Icon/IconWsjJapan';
import IconIbd from '../Icon/IconIbd';
import IconWsjcommerce from '../Icon/IconWsjcommerce';
import IconBuyside from '../Icon/IconBuyside';
import IconPenta from '../Icon/IconPenta';
import IconYdj from '../Icon/IconYdj';
import IconDjRiskJournal from '../Icon/IconDjRiskJournal';
export default {
  wsj: {
    name: 'The Wall Street Journal',
    value: 'wsj',
    image: IconWsj,
    background: '#222'
  },
  marketwatch: {
    name: 'MarketWatch',
    value: 'marketwatch',
    image: IconMarketwatch,
    background: '#2e2e2f'
  },
  barrons: {
    name: 'Barrons',
    value: 'barrons',
    image: IconBarrons,
    background: '#1a2737'
  },
  djriskjournal: {
    name: 'Dow Jones Risk Journal',
    value: 'rn',
    image: IconDjRiskJournal,
    background: '#fff',
    color: '#02A3D5'
  },
  fnlondon: {
    name: 'Financial News',
    value: 'fnlondon',
    image: IconFnlondon,
    background: '#f37056'
  },
  pen: {
    name: 'Private Equity News',
    value: 'pen',
    image: IconPen,
    background: '#1f3771'
  },
  mansionglobal: {
    name: 'Mansion Global',
    value: 'mansionglobal',
    image: IconMansionglobal,
    background: '#000'
  },
  mgboutique: {
    name: 'Mansion Global Boutique',
    value: 'mgboutique',
    image: IconMansionglobalBoutique,
    background: '#000'
  },
  dowjones: {
    name: 'Dow Jones',
    value: 'dowjones',
    image: IconDowjones,
    background: '#0c2a31',
    color: '#02a3d5'
  },
  thetimes: {
    name: 'The Times',
    value: 'thetimes',
    image: IconThetimes,
    background: '#000'
  },
  wsjopinion: {
    name: 'WSJ Opinion',
    value: 'wsjopinion',
    image: IconWsjopinion,
    background: '#fff',
    color: '#000'
  },
  cwsj: {
    name: 'WSJ China',
    value: 'cwsj',
    image: IconWsjChina,
    background: '#fff',
    color: '#000'
  },
  jwsj: {
    name: 'WSJ Japan',
    value: 'jwsj',
    image: IconWsjJapan,
    background: '#fff',
    color: '#000'
  },
  ibd: {
    name: 'Investors Business Daily',
    value: 'ibd',
    image: IconIbd,
    background: '#0065AA',
    color: '#fff'
  },
  wsjcommerce: {
    name: 'Buy Side',
    value: 'wsjcommerce',
    image: IconWsjcommerce,
    background: '#336666'
  },
  buyside: {
    name: 'Buy Side',
    value: 'buyside',
    image: IconBuyside,
    background: '#336666'
  },
  penta: {
    name: 'Penta',
    value: 'penta',
    image: IconPenta,
    background: '#fff',
    color: '#000'
  },
  ydj: {
    name: 'Dow Jones Yomiuri Pro',
    value: 'ydj',
    image: IconYdj,
    background: '#fff',
    color: '#000'
  }
};